module.exports = __webpack_public_path__ + "img/img_12.cf708029.png";